// Detecta em que subdomínio a app está a correr, para adaptar comportamento
// (ex: esconder secções que só fazem sentido para condomínios) sem depender
// de rotas ou de chamadas à API. Em `localhost` ou no domínio único ainda não
// migrado para subdomínios, devolve 'NEUTRO' — chamadores não devem tratar
// 'NEUTRO' como "esconder", só 'PROPRIEDADE'/'CONDOMINIO' são positivos.
export type Contexto = 'CONDOMINIO' | 'PROPRIEDADE' | 'NEUTRO'

export function getContexto(): Contexto {
    const host = window.location.hostname
    if (host.startsWith('cond')) return 'CONDOMINIO'
    if (host.startsWith('prop')) return 'PROPRIEDADE'
    return 'NEUTRO'
}
